import React from "react";
import { Alert, Box, Group, ScrollArea, Stack, Paper, Text, ThemeIcon } from "@mantine/core";
import { FaBriefcase, FaSortAmountDownAlt, FaHistory, FaInfoCircle, FaLock } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useGetMultiplacerProjectsQuery } from "../openapi";
import { useAppSelector } from "./app/hooks";
import { selectAvailableProjectsForUser } from "./projectSelectors";

export const Projects: React.FC = () => {
  const { isError, isLoading } = useGetMultiplacerProjectsQuery(undefined);

  const projects = useAppSelector(selectAvailableProjectsForUser);

  if (isLoading) {
    return <div>Laster...</div>;
  }

  return (
    <Box
      maw={600}
      mx="auto"
      mt="xl"
      p="md"
      bg="white"
      style={{ width: "100%", borderRadius: 8, boxShadow: "0 2px 5px rgba(0,0,0,0.1)" }}
    >
      {isError && <p>Error loading page</p>}

      <Text size="xl" fw={500} mb="sm">
        Prosjekter
      </Text>

      <Alert
        mb="md"
        variant="light"
        color="blue"
        title="Ønsker du å opprette et nytt prosjekt?"
        icon={<FaInfoCircle size={16} />}
      >
        Ta gjerne kontakt med Per Strom på per.strom@multiconsult.no, så hjelper han deg videre.
      </Alert>

      <Group mb="sm" justify="space-between">
        <Group gap="xs">
          <ThemeIcon variant="light" color="gray">
            <FaSortAmountDownAlt size={16} />
          </ThemeIcon>
          <ThemeIcon variant="light" color="gray">
            <FaHistory size={16} />
          </ThemeIcon>
        </Group>
      </Group>

      {projects.length === 0 ? (
        <Paper p="lg" withBorder radius="md">
          <Group align="flex-start" wrap="nowrap">
            <ThemeIcon variant="light" color="gray" size="lg">
              <FaLock size={16} />
            </ThemeIcon>

            <Box>
              <Text size="sm" fw={600}>
                Ingen tilgang til prosjekter
              </Text>
              <Text size="sm" c="dimmed">
                Du har for øyeblikket ikke tilgang til noen prosjekter. Ta kontakt med en
                prosjektadmin hvis du mener dette er feil.
              </Text>
            </Box>
          </Group>
        </Paper>
      ) : (
        <ScrollArea h={350}>
          <Stack>
            {projects.map((project) => (
              <Paper
                key={project.projectNo}
                p="sm"
                withBorder
                radius="md"
                component={Link}
                to={`/${project.projectNo}/design`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Group align="flex-start">
                  <ThemeIcon variant="light" size="lg">
                    <FaBriefcase size={16} />
                  </ThemeIcon>
                  <Box>
                    <Text size="sm" fw={500}>
                      {project.title}
                    </Text>
                    <Text size="xs" c="dimmed">
                      {project.projectNo}
                    </Text>
                  </Box>
                </Group>
              </Paper>
            ))}
          </Stack>
        </ScrollArea>
      )}
    </Box>
  );
};
